module.exports = __webpack_public_path__ + "img/logo_wcaworld.59bb30cf.jpg";